import React, { useEffect, useReducer, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useQuery } from 'react-query'
import CustomAddPage from '../../components/CustomComponents/CustomAddPage'
import { useModuleAdmins } from '../../hooks/Authentication/useModuleAdmins'
import { useSubscription } from '../../hooks/SuperAdmin/useSubscription'
import { useSuperAdmin } from '../../hooks/SuperAdmin/useSuperAdmin'
import { getAllData } from '../../lib/RestApi/customApiHandler'
import { Box, Button, Checkbox, FormControl, Grid, InputLabel, ListItemText, MenuItem, OutlinedInput, Select, TextField, Typography } from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete'
import {mod_permission} from '../../shared/constants'
const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
}

export default function AddSubscription() {
  // debugger
  const [subscriptionData, setsubscriptionData] = useState({
    subscriptionName: '',
    amount: '',
    modules: {allowed: []},
    discount: '',
    vailidityPeriod: 6,
    description: '',
    active: true,
    userLicense: 20,
  })
  const { subscriptionName, amount, modules, discount, vailidityPeriod, description, active, userLicense } = subscriptionData
  const [variantName, setVariantName] = useState([])
  const [searchQuery, setSearchQuery] = useState('')
  const [tempModule, setTempModule] = useState({})
  const { data: permissions, isLoading } = useQuery(['company-permissions'], () => getAllData('permissions'))
  const { addSubscription, loading, updateSubscription, getSubscription, subscription } = useSubscription()
  const { getAllModuleAdmins, moduleAdmin } = useModuleAdmins()
  const [ignored, forceUpdate] = useReducer((x) => x + 1, 0)
  const param = useParams()
  function handleClickNew() {
    forceUpdate()
  }

  useEffect(() => {
    if (subscription) {
      setsubscriptionData({ ...subscription, discount: subscription.discount['$numberDecimal'] })
    }
  }, [subscription])

  useEffect(() => {
    if (param.id !== undefined) {
      getSubscription({ id: param.id })
      // setsubscriptionData({ ...subscription, modules: Object.keys(tempModule), subPermissions: Object.values(tempModule) })
    }
  }, [param])


  const handleSubmit = () => {
    console.log('submitting details')
    if (param.id !== undefined) {
      updateSubscription({ ...subscriptionData })
    } else {
      console.log('poi', subscriptionData)
      addSubscription({ ...subscriptionData })
    }
  }
  useEffect(() => {
    console.log(moduleAdmin)
  }, [])

  useEffect(() => {
    console.log('tempModule====>', tempModule)
  }, [tempModule])

  const optionsAll = [
    { value: {module: 'ATTENDANCE', subPermission: mod_permission}, label: 'Attendence' },
    { value: {module: 'EMPLOYEE', subPermission: mod_permission}, label: 'Employee' },
    { value: {module: 'PRODUCT', subPermission: mod_permission}, label: 'Product Catalogue' },
    { value: {module: 'MARKETING', subPermission: mod_permission}, label: 'Marketing' },
    { value: {module: 'BEAT', subPermission: mod_permission}, label: 'Beat Plan' },
    { value: {module: 'CHECKIN_CHECKOUT', subPermission: mod_permission}, label: 'Check-in Check-out' },
    { value: {module: 'LEAD', subPermission: mod_permission}, label: 'Manage leads' },
    { value: {module: 'REWARDS', subPermission: mod_permission}, label: 'Rewards & Recognition' },
    { value: {module: 'TARGET_INCENTIVES', subPermission: mod_permission}, label: 'Target & Incentives' },
    { value: {module: 'EXPENSE', subPermission: mod_permission}, label: 'Expense' },
    { value: {module: 'ORDER', subPermission: mod_permission}, label: 'Orders' },
    { value: {module: 'LEARNING', subPermission: mod_permission}, label: 'Learning & Development' },
    { value: {module: 'AUDIT', subPermission: mod_permission}, label: 'Audit' },
    { value: {module: 'DEALER_ONBOARDING', subPermission: mod_permission}, label: 'Dealer Onbording' },
    { value: {module: 'INVENTORY', subPermission: mod_permission}, label: 'Inventory Management' },
    { value: {module: 'SALES', subPermission: mod_permission}, label: 'Sales' },
    { value: {module: 'MULTI_COUNTRY_CURRENCY', subPermission: mod_permission}, label: 'Multi Country & Multi Currency' },
    { value: {module: 'TRAVEL_ALLOWANCE', subPermission: mod_permission}, label: 'Travel Allowance' },
  ]

  console.log('kope', permissions)

  const data = [
    { label: 'Name', value: subscriptionData.subscriptionName, name: 'subscriptionName', conditions: [{ type: 'subscriptionName' }] },
    { label: 'User License', value: subscriptionData.userLicense, name: 'userLicense', conditions: [{ type: 'userLicense' }] },
    { label: 'Description', value: subscriptionData.description, name: 'description' },
    { label: 'Validity Period in Months', value: subscriptionData.vailidityPeriod, name: 'vailidityPeriod', conditions: [{ type: 'Number' }] },
    { label: 'Amount', value: subscriptionData.amount, name: 'amount', type: 'amount', noDisplay: subscription ? true : false },
    { label: 'Discount in Percentage', value: subscriptionData.discount, name: 'discount' },
    // { label: 'permissions', value: subscriptionData.modules, name: 'modules', options: optionsAll, fieldName: 'label', fieldValue: 'value' },
  ]

  const handleChange = (e) => {
    setsubscriptionData({ ...subscriptionData, [e.target.name]: e.target.value })
  }

  const handleChangePermission = (event) => {
    const {
      target: { value },
    } = event

    // setVariantName(
    //   // On autofill we get a stringified value.
    //   typeof value === 'string' ? value.split(',') : value
    // )
    console.log({value})
    // setVariantName([...variantName, value])
    // const cpy = [...subscriptionData.modules.allowed]
    // cpy.push({module: value[0].module, subPermission: value[0].subPermission})

    setsubscriptionData({ ...subscriptionData, modules: {"allowed": value} })
    setVariantName(value)

    // console.log('lp', value)

    // let duplicateRemoved = []

    // value.forEach((item) => {
    //   if (duplicateRemoved.findIndex((o) => o.label === item.label) >= 0) {
    //     console.log('lp1', item)
    //     duplicateRemoved = duplicateRemoved.filter((x) => x.label === item.label)
    //   } else {
    //     console.log('lp2', item)
    //     duplicateRemoved.push(item)
    //   }
    // })
    // console.log('lp3', duplicateRemoved)
    // setVariantName(event.target.value)
  }
  // console.log('pop', subscriptionData)
  // console.log('poi', variantName)

  return (
    <>
      <CustomAddPage
        heading="Subscriptions"
        redirect="ALL_SUBSCRIPTION_PLANS"
        currentData={subscription}
        loading={loading}
        state={subscriptionData}
        setState={setsubscriptionData}
        handleClick={handleSubmit}
        inputFields={data}
        // modules={modules}
        // // setModules={setModules}
        // tempModule={tempModule}
        // setTempModule={(obj) => {
        //   setTempModule(obj)
        //   handleClickNew()
        // }}
      />
      <div style={{ marginLeft: '260px', marginTop: '-240px', marginRight: '94px', padding: '1rem', borderRadius: '0.66rem' }}>
        {/* <div style={{ borderBottom: '1px solid lightgrey' }}>
          <p style={{ fontWeight: '600', fontSize: '1.1rem' }}>Add Subscription</p>
        </div> */}
        <Box style={{ marginTop: '2rem' }}>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={5} p={5}>
              {/* <Grid item xs={4}>
                <FormControl fullWidth>
                  <TextField onChange={handleChange} name="subscriptionName" value={subscriptionName} label="Subscription Name" variant="outlined" />
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <FormControl fullWidth>
                  <TextField onChange={handleChange} name="amount" value={amount} label="Amount" variant="outlined" />
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <FormControl fullWidth>
                  <TextField onChange={handleChange} name="userLicense" value={userLicense} label="User License" variant="outlined" />
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <FormControl fullWidth>
                  <TextField onChange={handleChange} name="description" value={description} label="Description" variant="outlined" />
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <FormControl fullWidth>
                  <TextField onChange={handleChange} name="vailidityPeriod" value={vailidityPeriod} label="Validity Period in Months" variant="outlined" />
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <FormControl fullWidth>
                  <TextField onChange={handleChange} name="discount" value={discount} label="Discount" variant="outlined" />
                </FormControl>
              </Grid> */}
              <Grid item xs={12} fullWidth>
                <FormControl fullWidth>
                  {/* <InputLabel id="demo-multiple-checkbox-label">Permission</InputLabel> */}
                  <Select
                    labelId="demo-multiple-name-label"
                    id="demo-multiple-name"
                    multiple
                    fullWidth
                    value={variantName}
                    label="Permission"
                    onChange={handleChangePermission}
                    renderValue={(selected) => {
                      console.log({selected})
                      return selected.map((item)=>{
                        return item.module + ", "
                      })
                    }}
                    MenuProps={MenuProps}
                  >
                    {optionsAll.map((name) => {
                      // console.log("map value", name.value, variantName, variantName.indexOf(name.value))
                      // console.log({variantName})
                      return <MenuItem key={name.label} value={name.value}>
                        <Checkbox checked={variantName?.map(item => item.module).indexOf(name.value.module) > -1} />
                        <ListItemText primary={name.label} />
                      </MenuItem>
                    })}
                  </Select>
                </FormControl>
              </Grid>
              {/* <Grid item xs={4}>
                <Button type="submit" variant="contained" fullWidth>
                  Submit
                </Button>
              </Grid>
              <Grid item xs={4}>
                <Button type="submit" variant="contained" fullWidth>
                  Cancel
                </Button>
              </Grid> */}
            </Grid>
          </form>
        </Box>
        {/* <FormControl variant="standard" fullWidth sx={{ m: 1 }}>
          <InputLabel id="demo-multiple-checkbox-label">Permission</InputLabel>
          <Select
            labelId="demo-multiple-name-label"
            id="demo-multiple-name"
            multiple
            fullWidth
            value={variantName}
            onChange={handleChangePermission}
            renderValue={(selected) => selected.join(', ')}
            input={<OutlinedInput label="Permission" />}
            MenuProps={MenuProps}
          >
            {optionsAll.map((name) => (
              <MenuItem key={name.label} value={name.value}>
                <Checkbox checked={variantName.indexOf(name.value) > -1} />
                <ListItemText primary={name.label} />
              </MenuItem>
            ))}
          </Select>
        </FormControl> */}
      </div>
    </>
  )
}
